















import { listFactory } from '@/main/pages';
import { TabulkovaPozice } from '@/modules/ciselnik/dilenske/tabulkovaPozice';

import { NAME } from './constants';
import { store } from './store/list';
import { listMutations } from './store/types';

export default listFactory(NAME, store).extend({
	components: {
		TabulkovaPoziceSelect: TabulkovaPozice.components.Select,
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				tabulkovaPozice: `${this.storeUri}/${listMutations.TABULKOVA_POZICE_SELECT_MAPPER}`,
			};
		},
	},
});
